module.exports = __webpack_public_path__ + "img/food6.5d76025d.jpg";